import {
  ChoiceData,
  getChoicesData,
} from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/actions/helpers/getChoicesData";

/** Helper function to get the ID of a choice from a list of choices. */
const getChoiceId = (value: string, choices: ChoiceData[]) => {
  return choices.find((choice) => choice.choice === value)?.id;
};

/** Helper function to get the form payload. */
export const getFormPayload = async ({
  email,
  name,
  sector,
  country,
  seniority,
  otherSector,
  newsletterConsent,
}: {
  email: string;
  name: string;
  sector: string;
  country: string;
  seniority: string;
  otherSector: string;
  newsletterConsent: boolean;
}) => {
  const { sectorChoices, seniorityChoices } = await getChoicesData();

  const sectorId = getChoiceId(sector, sectorChoices);
  const seniorityId = getChoiceId(seniority, seniorityChoices);

  const newsletterObj = { "31": 1, "64679": 1 };
  const payload = {
    key_id: "3",
    "1": name,
    "3": email,
    "65379": sectorId || sector,
    "14": country,
    "65381": seniorityId || seniority,
    "65380": otherSector || "",
    ...(newsletterConsent ? newsletterObj : {}),
  };

  return payload;
};
